export class GetGdsgRegionStatsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "windowStartMs",
            "baseName": "windowStartMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "windowEndMs",
            "baseName": "windowEndMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bucketIntervalMs",
            "baseName": "bucketIntervalMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<GdsgRegionStats>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetGdsgRegionStatsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
